import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css"



class Navbar extends React.Component {

    render(){

      let isTrue = false;
      if(window.location.pathname === "/")
        isTrue = true;

        return (
        <section className="sticky-top">
            <nav className="navbar navbar-light bg-white navbar-expand-lg">
                <a className="navbar-brand" href="/">
                    <img className="teamLogo" src="../../../images/logos/teamX_Logo-01.png"/>
                </a>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navToggle"
                    aria-controls="navToggle"
                    aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navToggle">
                    <ul className="navbar-nav ml-auto mt-2 mt-lg-0 text-center">
                    <li className={`options`}>

                            <a className={`nav-link ${isTrue ? "active-class" : null}`} href="/">

                                Home

                            </a>
                        </li>

                        <li className={`options`}>

                            <a className={`nav-link ${JSON.stringify(window.location.href).includes("services") ? "active-class" : null}`} href="/services">

                                Services

                            </a>
                        </li>

                        <li className={`options`}>
                            <a className={`nav-link ${JSON.stringify(window.location.href).includes("work") ? "active-class" : null}`} href="/work">

                                Clients

                            </a>
                        </li>

                        <li className={`options`}>
                            <a className={`nav-link ${JSON.stringify(window.location.href).includes("about") ? "active-class" : null}`} href="/about">

                                Our Team

                            </a>
                        </li>

                        <li className="options Rectangle-4">
                            <a id="Contact" className="nav-link" href="/#contact">

                                Contact

                            </a>
                        </li>

                    </ul>

                </div>
            </nav>
        </section>
    );
}
};

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar/Navbar.js